"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var EmbedWidget_1 = __importDefault(require("../EmbedWidget/EmbedWidget"));
var WidgetManager_1 = require("../../WidgetManager");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var slate_react_1 = require("slate-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var GoogleMaps_1 = require("ContentTokens/Models/GoogleMaps");
var Types_2 = require("Tokens/Types");
var lodash_1 = require("lodash");
var PlaceholderImage = function () { return (react_1.default.createElement("div", { className: "google-maps-placeholder" },
    react_1.default.createElement("img", { src: "Assets/Images/GoogleMapsPlaceholder.jpg", className: "google-maps-placeholder__img" }),
    react_1.default.createElement("div", { className: "google-maps-placeholder__grouping" },
        react_1.default.createElement(kaleidoscope_1.SVG, { src: "/Assets/icons/GoogleMaps.svg" }),
        react_1.default.createElement("div", { className: "google-maps-placeholder__instructions", contentEditable: false },
            "To find the embed code for a Google Map,",
            react_1.default.createElement("br", null),
            react_1.default.createElement("a", { href: "https://support.google.com/maps/answer/3544418?hl=en&rd=1", target: "_blank", className: "google-maps-placeholder__link link-styler" }, "follow these instructions"))))); };
var GoogleMapsWidget = function (props) {
    var triggerWidgetEvent = function (eventData) {
        props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.GoogleMaps, eventData));
    };
    var handleDisplayUrlChange = function (displayUrl) { return __awaiter(void 0, void 0, Promise, function () {
        var updateData, embedUrl;
        return __generator(this, function (_a) {
            updateData = {
                action: "update",
                path: slate_react_1.ReactEditor.findPath(props.widgetManager.editor, props.element),
            };
            if (displayUrl === "") {
                updateData.toUpdate = { displayUrl: displayUrl, embedUrl: "" };
                props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.GoogleMaps, updateData));
            }
            else {
                embedUrl = (0, GoogleMaps_1.convertToEmbedUrl)(displayUrl);
                if (props.embedUrl != embedUrl) {
                    updateData.toUpdate = { displayUrl: embedUrl, embedUrl: embedUrl };
                    props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.GoogleMaps, updateData));
                }
            }
            return [2];
        });
    }); };
    var variableDetails = {
        variable: props.variable,
        instructions: "Add a Google maps embed URL",
        icon: icons_1.BlockEmbed,
    };
    return (react_1.default.createElement(EmbedWidget_1.default, __assign({ embedType: "map", key: props.embedUrl }, props, { isSelected: props.isSelected || props.toolbarBeingUsed, displayUrl: props.displayUrl, minWidthPx: 280, placeholder: react_1.default.createElement(PlaceholderImage, null), placeholderText: "Add a Google maps embed URL", triggerWidgetEvent: triggerWidgetEvent, handleDisplayUrlChange: handleDisplayUrlChange, errorMsg: "Sorry, that doesn't seem to be a valid embed URL. Double check the value and try again.", allowVariables: props.enableTokens !== Types_2.TokensEnableState.Disabled || !(0, lodash_1.isUndefined)(props.variable), variableDetails: variableDetails })));
};
exports.default = GoogleMapsWidget;
